import { getRoute } from "@utils/route";

export const CANCER_INSURANCE_PAGE_URL = '/cancer-insurance';

export const routeCancerInsurancePage = () => getRoute(CANCER_INSURANCE_PAGE_URL);
